import React, { useRef } from 'react';
import { useHoverDirty } from 'react-use';
import IconArrow from '@components/icons/IconArrow';
import Button from '@components/Button';
import VipWrapper from '@components/VipWrapper';
import showVipPrompt from '@components/ConfirmModal/showVipPrompt';

interface Props {
  title: string;
  showVip?: boolean;
  subtitle?: string;
  onClick: () => void;
}

function PanelBtn({ title, showVip, subtitle, onClick }: Props) {
  const ref = useRef(null);
  const isHovered = useHoverDirty(ref);
  return (
    <Button
      scheme="dark"
      className="mb-10 w-full"
      ref={ref}
      onClick={() => {
        onClick();
        if (showVip) {
          showVipPrompt();
        }
      }}
    >
      <VipWrapper showVip={showVip}>{title}</VipWrapper>
      <div className="flex-direction ml-auto flex">
        {subtitle && <div className="mr-5 text-black-gray">{subtitle}</div>}
        <IconArrow active={isHovered} className="-rotate-90 transform" />
      </div>
    </Button>
  );
}

export default PanelBtn;
